import axiosClient from './axiosClient';
import { IApiBaseResponse } from '~/utils/interface/common';
import {
  IEditEventPayload,
  IParamsGetScheduleEvent,
  IPayloadDeleteEvents,
  IResponseGetScheduleEvent,
  IResponseGetSchedules,
  ICreateSchedulePayload,
  ICreateScheduleResponse,
  IScheduleDetailResponse,
} from '~/utils/interface/schedule';

const scheduleEventApi = {
  getEvents(params: IParamsGetScheduleEvent) {
    const url = `/api/schedules`;
    // Build query params with array format for assigneeId, subcontractorId, appointmentType
    const queryParams: Record<string, string> = {};
    
    if (params.from) queryParams.from = params.from;
    if (params.to) queryParams.to = params.to;
    if (params.relatedJobId) queryParams.relatedJobId = params.relatedJobId.toString();
    if (params.assigneeId && params.assigneeId.length > 0) {
      params.assigneeId.forEach((id, index) => {
        queryParams[`assigneeId[${index}]`] = id.toString();
      });
    }
    if (params.subcontractorId && params.subcontractorId.length > 0) {
      params.subcontractorId.forEach((id, index) => {
        queryParams[`subcontractorId[${index}]`] = id.toString();
      });
    }
    if (params.appointmentType && params.appointmentType.length > 0) {
      params.appointmentType.forEach((type, index) => {
        queryParams[`appointmentType[${index}]`] = type;
      });
    }
    
    return axiosClient.get<IApiBaseResponse<IResponseGetSchedules>>(url, { params: queryParams });
  },
  createSchedule(payload: ICreateSchedulePayload) {
    const url = `/api/schedules/create`;
    return axiosClient.post<IApiBaseResponse<ICreateScheduleResponse>>(url, payload);
  },
  addEvent(newEventPayload: IEditEventPayload) {
    const url = `/api/admin/events`;
    return axiosClient.post<IApiBaseResponse<any>>(url, newEventPayload);
  },
  getEvent(id: string) {
    const url = `/api/admin/events/${id}`;
    return axiosClient.get<IApiBaseResponse<IEditEventPayload>>(url);
  },
  updateEvent(id: string, data: IEditEventPayload) {
    const url = `/api/admin/events/${id}`;
    return axiosClient.put<IApiBaseResponse<any>>(url, data);
  },
  deleteEvent(data: IPayloadDeleteEvents) {
    const url = `/api/admin/events`;
    return axiosClient.delete<IApiBaseResponse<null>>(url, { data });
  },
  getScheduleById(id: number) {
    const url = `/api/schedules/${id}`;
    return axiosClient.get<IApiBaseResponse<IScheduleDetailResponse>>(url);
  },
  updateSchedule(id: number, payload: ICreateSchedulePayload) {
    const url = `/api/schedules/${id}`;
    return axiosClient.put<IApiBaseResponse<ICreateScheduleResponse>>(url, payload);
  },
  deleteSchedule(id: number) {
    const url = `/api/schedules/${id}`;
    return axiosClient.delete<IApiBaseResponse<null>>(url);
  },
};

export default scheduleEventApi;
